import classNames from 'classnames'
import { Checkbox } from 'components'
import { selectLanguageBasedOnBrowserLocale } from 'locale'
import PropTypes from 'prop-types'
import React from 'react'
import { countryIdToString, countryShortNameToString } from 'utils'

import Box from '@mui/material/Box'

const FilterCountryModalTableRow = ({ countryID, isChecked, onSelect, ...props }) => {
  const countryNameLocale = props[`countryName${selectLanguageBasedOnBrowserLocale().toUpperCase()}`]
  const countryShortName = (countryNameLocale || '').split(' ').pop()
  const fallbackCountryName = countryID && countryIdToString(countryID)
  const onChange = () => onSelect(countryID)

  return (
    <div className="filter-country-modal-table-row">
      <Box className={classNames('row-wrapper flex-row', { selected: isChecked })} onClick={onChange}>
        <div className="cell cell-title flex-row">
          <div
            className={classNames('flag', `flag-${countryShortNameToString(countryShortName, fallbackCountryName)}`, {
              'hide-flag': !countryID,
            })}
          />

          {countryNameLocale}
        </div>

        <div className="cell cell-checkbox">
          <Checkbox isChecked={isChecked} onChange={onChange} />
        </div>
      </Box>
    </div>
  )
}

FilterCountryModalTableRow.propTypes = {
  countryID: PropTypes.string,
  countryNameEN: PropTypes.string,
  countryNamePL: PropTypes.string,
  isChecked: PropTypes.bool,
  onSelect: PropTypes.func,
}

export default FilterCountryModalTableRow
